import FeedBacks from '../../components/feedBacks/FeedBacks';

const FeedBacksPage = () => {
  return <FeedBacks />;
};
export default FeedBacksPage;
